import React, { Component, useEffect, useState } from 'react';

// @material-ui/icons
import ViewModule from '@material-ui/icons/ViewModule';
import AllInbox from '@material-ui/icons/AllInbox';
import VerticalSplit from '@material-ui/icons/VerticalSplit';
import People from '@material-ui/icons/People';
import SearchIcon from '@material-ui/icons/Search';
import CallToActionIcon from '@material-ui/icons/CallToAction';
import Settings from '@material-ui/icons/Settings';
import EventNote from '@material-ui/icons/EventNote';

// core components
import CustomTabs from 'components/CustomTabs/CustomTabs.js';
import LockerStruct from 'components/LockerStruct';
import ListAltIcon from '@material-ui/icons/ListAlt';
import Orders from 'components/Orders/Orders';
import Slots from 'components/Slots/Slots';
import Users from 'components/Users/Users';
import Usuario from 'views/Usuarios'
import Condomino from 'views/Condomino'
import Operadores from 'views/Operadores'
import Events from 'components/Events/Events';
import Search from 'components/Search/Search';
import SearchOperations from 'components/Search/SearchOperations';
import Action from 'components/Action/Action';
// import LockerConfig from 'components/LockerConfig';
import LockerConfig from 'components/LockerConfig/LockerConfigFabrika';

// Criados por Fabrika de Softwares
import LockerOperations from 'views/Lockers/LockersOperations';
import EventsFabrika from 'components/Events/EventsFabrika';
import Tooltip from '@material-ui/core/Tooltip';


class DefaultLockerOptions extends Component {

  render() {
    const { lockerId, lockerName, role } = this.props;

    console.log(role)

    return (
      role == 'Administrador' ? 
      <CustomTabs
        title={lockerName}
        headerColor="primary"
        tabs={[
          {
            tabName: 'Locker',
            tabIcon: ViewModule,
            tabContent: <LockerStruct lockerId={lockerId} />,
          },
          {
            tabName: 'Encomendas',
            tabIcon: AllInbox,
            tabContent: <Orders lockerId={lockerId} />,
          },
          {
            tabName: 'Porta',
            tabIcon: VerticalSplit,
            tabContent: <Slots lockerId={lockerId} />,
          },
          {
            tabName: 'Condôminos',
            tabIcon: People,
            tabContent: <Condomino lockerId={lockerId} />,
          },
          // {
          //   tabName: 'Operadores',
          //   tabIcon: People,
          //   tabContent: <Operadores lockerId={lockerId} />,
          // },
          // {
          //   tabName: 'Ações',
          //   tabIcon: CallToActionIcon,
          //   tabContent: <Action lockerId={lockerId} lockerName={lockerName} />,
          // },
          // {
          //   tabName: 'Eventos',
          //   tabIcon: ListAltIcon,
          //   tabContent: <EventsFabrika lockerId={lockerId} />,
          //   // tabContent: <Events lockerId={lockerId} />
          // },
          {
            tabName: 'Operações',
            tabIcon: EventNote,
            tabContent: <LockerOperations lockerId={lockerId} />,
          },
          {
            tabName: 'Configurações',
            tabIcon: Settings,
            tabContent: <LockerConfig lockerId={lockerId} lockerName={lockerName} />,
          },
        ]}
      /> : 
      <CustomTabs
        title={lockerName}
        headerColor="primary"
        tabs={[
          {
            tabName: 'Locker',
            tabIcon: ViewModule,
            tabContent: <LockerStruct lockerId={lockerId} />,
          },
          {
            tabName: 'Encomendas',
            tabIcon: AllInbox,
            tabContent: <Orders lockerId={lockerId} />,
          },
          {
            tabName: 'Condôminos',
            tabIcon: People,
            tabContent: <Condomino lockerId={lockerId} />,
          },
          // {
          //   tabName: 'Operadores',
          //   tabIcon: People,
          //   tabContent: <Operadores lockerId={lockerId} />,
          // },
          // {
          //   tabName: 'Eventos',
          //   tabIcon: ListAltIcon,
          //   tabContent: <EventsFabrika lockerId={lockerId} />,
          //   // tabContent: <Events lockerId={lockerId} />
          // },
        ]}
      />
    );
  }
}

export default DefaultLockerOptions;
